module.exports = __webpack_public_path__ + "img/cp.5ec1a10e.jpg";